import styled from "styled-components"

export const NextWrapper = styled.div`
    padding-top: 2rem;
    padding-bottom: 2rem;
`



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/Next/styled.js